import { Box, Button, Menu, Typography } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

export const SchoolStaffSearchHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '100%'
}));

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  width: '100%'
}));

export const ProfileImageBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  maxWidth: '170px'
}));

export const ImagePreview = styled('img')(() => ({
  width: '100%',
  height: 180,
  borderRadius: 8,
  objectFit: 'cover'
}));

export const HelperText = styled(Typography).attrs({
  as: 'h5',
  variant: 'h5'
})(() => ({
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: 400,
  marginTop: 8,
  width: 'fit-content',
  lineHeight: '22px',
  color: pallet.lightBlueText
}));

export const UploadButton = styled(Button)(() => ({
  border: `2px solid ${pallet.primary} !important`,
  color: pallet.primary,
  borderRadius: '8px !important',
  textTransform: 'none',
  fontWeight: 500,
  textWrap: 'nowrap',
  padding: '6px, 12px',
  background: 'transparent',
  width: 'fit-content !important',
  '&:hover': {
    background: pallet.selectedBackground,
    borderColor: pallet.primaryHover
  }
}));

export const ActiveContainer = styled(Box)<{
  backgroundColor?: string;
  color?: string;
}>(({ backgroundColor, color }) => ({
  backgroundColor: backgroundColor || pallet.lightGreen,
  color: color || pallet.green2,
  paddingInline: 12,
  paddingBlock: 4,
  borderRadius: 4,
  fontWeight: 500,
  fontSize: 16,
  height: 'max-content'
}));

export const ActionsMenu = styled(Menu).attrs(() => ({
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transformOrigin: { vertical: 'top', horizontal: 'right' }
}))(() => ({
  '& .MuiPaper-root': {
    marginTop: 8,
    borderRadius: 16,
    border: `1px solid ${pallet.borderBackground}`,
    overflow: 'hidden',
    minWidth: 220,
    boxShadow: 'none'
  }
}));

export const StaffFormWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 48,
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    gap: 8,
    alignItems: 'center'
  }
}));

export const StaffFormInputWrapper = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  maxWidth: '684px',
  marginTop: 16,
  gap: 16,
  '@media (max-width: 900px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
    maxWidth: '456px'
  },
  '@media (max-width: 600px)': {
    gridTemplateColumns: '1fr',
    maxWidth: '100%'
  }
}));

export const InputFieldWrapper = styled(Box)(() => ({
  maxWidth: '280px',
  '@media (max-width: 900px)': {
    maxWidth: '100%'
  }
}));

export const AcademicYearHeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'start',
  gap: 0,
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginBottom: 16
  }
}));

export const DeleteClassButton = styled(Button)(() => ({
  width: '38px !important',
  minWidth: '38px !important',
  borderRadius: '8px !important',
  padding: '0px !important'
}));

export const SectionTitleText = styled(Typography).attrs({
  variant: 'h5',
  as: 'h5'
})(() => ({
  margin: 0,
  fontWeight: 'bold',
  fontSize: '24px',
  color: pallet.formLabelText,
  alignItems: 'center',
  marginBottom: 0,
  '@media (max-width: 600px)': {
    fontSize: '18px',
    marginBottom: 8
  }
}));

export const AcademicYearInfoActionWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  mt: { xs: 4, sm: 0 }
}));

export const ActionWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const ProfileFormWrapper = styled(Box)(() => ({
  flex: 1,
  width: '100%'
}));

export const TableProfileWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16
}));

export const RoundedButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  width: 'auto',
  borderRadius: '8px !important',
  '@media (max-width:600px)': {
    width: '100%'
  }
});

export const ActionButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})<{ isActionsOpen?: boolean }>(({ isActionsOpen }) => ({
  borderRadius: '8px !important',
  'aria-controls': isActionsOpen ? 'actions-menu' : undefined,
  'aria-haspopup': 'true',
  'aria-expanded': isActionsOpen ? 'true' : undefined
}));

export const SaveActionButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const ClassFormWrapper = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',
  '@media (max-width:600px)': {
    gridTemplateColumns: '1fr'
  }
}));

export const profileImgStyle = {
  width: 34,
  height: 34,
  borderRadius: '50%',
  objectFit: 'cover',
  background: pallet.lightGrey
} as React.CSSProperties;

export const ButtonContainer = styled(Box)<{ isWrapped?: boolean }>(
  ({ isWrapped }) => ({
    display: 'flex',
    flex: 1,
    justifyContent: isWrapped ? 'flex-start' : 'flex-end',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    marginLeft: 'auto'
    // width: '100%'
  })
);
